/**
 * Comprime una imagen en el cliente antes de subirla:
 * - Reescala si excede maxWidth (mantiene proporción, no upscalea).
 * - Pinta fondo blanco (evita "negro" al convertir PNG con alpha a JPEG).
 * - Exporta como JPEG con la calidad indicada.
 * - Devuelve un File nuevo con el mismo nombre del original.
 *
 * Defaults (1920 / 0.8) son los usados por el módulo de Recepciones
 * y unificados para todas las vistas del proyecto.
 */
export async function compressImage(file, maxWidth = 1920, quality = 0.8) {
  return new Promise((resolve) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const img = new Image();

      img.onload = () => {
        const canvas = document.createElement('canvas');

        let width = img.width;
        let height = img.height;

        if (width > maxWidth) {
          height = (height * maxWidth) / width;
          width = maxWidth;
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        ctx.fillStyle = '#FFFFFF';
        ctx.fillRect(0, 0, width, height);
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            resolve(new File([blob], file.name, {
              type: 'image/jpeg',
              lastModified: Date.now()
            }));
          },
          'image/jpeg',
          quality
        );
      };

      img.src = e.target.result;
    };

    reader.readAsDataURL(file);
  });
}
